module.exports = __webpack_public_path__ + "static/matalotok-4a26766d9ba0e2562b59fe91e94d199c.jpeg";